import { render, staticRenderFns } from "./FormPlanos.vue?vue&type=template&id=3d7623df&scoped=true"
import script from "./FormPlanos.vue?vue&type=script&lang=js"
export * from "./FormPlanos.vue?vue&type=script&lang=js"
import style0 from "./FormPlanos.vue?vue&type=style&index=0&id=3d7623df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7623df",
  null
  
)

export default component.exports